import dayjs from 'dayjs';

export const CUSTOMER_ORDER_STATUS_CARDS = [
  {
    key: 'received',
    title: '접수',
    statuses: ['RECEIVED', 'CHARGING'],
  },
  {
    key: 'shipping',
    title: '배송중',
    statuses: ['SHIPPING'],
  },
  {
    key: 'completed',
    title: '완료',
    statuses: ['DELIVERED'],
  },
  {
    key: 'canceled',
    title: '취소',
    statuses: ['CANCELED'],
  },
];

const getOrderSortValue = (order) => {
  if (order?.createdAt) return dayjs(order.createdAt).valueOf();
  if (order?.orderDate) return dayjs(order.orderDate).valueOf();
  return 0;
};

export const sortOrdersByLatest = (orders = []) => {
  return [...orders].sort((left, right) => getOrderSortValue(right) - getOrderSortValue(left));
};

export const buildOrderStatusSummary = (orders = []) => {
  return CUSTOMER_ORDER_STATUS_CARDS.reduce((summary, card) => {
    summary[card.key] = orders.filter((order) => card.statuses.includes(order.status)).length;
    return summary;
  }, {});
};

export const getRecentOrders = (orders = [], limit = 10) => {
  return sortOrdersByLatest(orders).slice(0, limit);
};

export const buildOrderChartData = (orders = [], from, to) => {
  if (!from || !to) return [];

  const nextData = [];
  let currentDate = from.startOf('day');
  const endDate = to.startOf('day');

  while (currentDate.isSame(endDate, 'day') || currentDate.isBefore(endDate, 'day')) {
    const targetDate = currentDate.format('YYYYMMDD');
    const targetLabel = currentDate.format('M/D');

    nextData.push({
      label: targetLabel,
      date: targetDate,
      count: orders.filter((order) => dayjs(order.orderDate).format('YYYYMMDD') === targetDate).length,
    });

    currentDate = currentDate.add(1, 'day');
  }

  return nextData;
};

export const filterOrdersByDate = (orders = [], yyyymmdd) => {
  return orders.filter((order) => dayjs(order.orderDate).format('YYYYMMDD') === yyyymmdd);
};
